import React from "react";
import styles from "../SkeletonStyles.module.css";
import { Skeleton } from "@mui/material";

function AttendanceSkeleton() {
  return (
    <div className={styles.batchBasicDetailsWrap} style={{ padding: "10px" }}>
      <div className={styles.batchBasicDetailsHead}>
        <Skeleton animation="wave" variant="text" width="20%" height={50} />
        <Skeleton animation="wave" variant="text" width="25%" height={20} />
      </div>
      <div style={{ padding: "10px 20px" }}>
        <div
          style={{
            width: "100%",
            marginBottom: "20px",
          }}
        >
          <Skeleton animation="wave" variant="text" width="100%" height={25} />
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>
      <div className={styles.batchBasicDetailsHead}>
        <Skeleton animation="wave" variant="text" width="20%" height={50} />
        <Skeleton animation="wave" variant="text" width="25%" height={20} />
      </div>
      <div style={{ padding: "10px 20px" }}>
        <div
          style={{
            width: "100%",
            marginBottom: "20px",
          }}
        >
          <Skeleton animation="wave" variant="text" width="100%" height={25} />
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>
      <div className={styles.batchBasicDetailsHead}>
        <Skeleton animation="wave" variant="text" width="20%" height={50} />
        <Skeleton animation="wave" variant="text" width="25%" height={20} />
      </div>
      <div style={{ padding: "10px 20px" }}>
        <div
          style={{
            width: "100%",
            marginBottom: "20px",
          }}
        >
          <Skeleton animation="wave" variant="text" width="100%" height={25} />
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>
    </div>
  );
}

export default AttendanceSkeleton;
